import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui";
import {
  DEMAND_TYPES,
  type DemandType,
} from "@/lib/data/requests/reports/reports-matter-demand-report";

export const DEMAND_TYPE_LABELS: Record<DemandType, string> = {
  FIRST_PARTY: "First party",
  THIRD_PARTY: "Third party",
  UNCLASSIFIED: "Unclassified",
};

export function DemandTypeFilter({
  onChange,
}: {
  onChange: (value: DemandType) => void;
}) {
  return (
    <Select
      value=""
      onValueChange={(value) => {
        onChange(value as DemandType);
      }}
    >
      <SelectTrigger className="h-11">
        <SelectValue placeholder="Demand type" />
      </SelectTrigger>
      <SelectContent>
        {DEMAND_TYPES.map((value) => (
          <SelectItem key={value} value={value}>
            {DEMAND_TYPE_LABELS[value]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
